export enum UserFeatureStatusEnum {
  On = 'on',
  Off = 'off',
}
